import Helper from './Helper';

class Cv {
  constructor(config = {}) {
    const {} = config;
    this.cvs = Array.prototype.slice.call(document.querySelectorAll('.lc-cv'));

    if (this.cvs && this.cvs.length !== 0) {
      this.bindEvents();
    }
  }

  bindEvents() {
    this.cvs.forEach(el => {
      const buttons = el.querySelectorAll('.lc-cv__button-container, .lc-cv__header-close');
      const content = el.querySelector('.lc-cv__content');
      buttons.forEach(button => {
        button.addEventListener('click', (e) => {
          if (el.classList.contains('open')) {
            Helper.slideClose(content);
            el.classList.remove('open');
          } else {
            Helper.slideOpen(content);
            el.classList.add('open');
          }
        })
      });
    });
  }
}

export default Cv;
